import React, { useState, useEffect, useRef } from 'react'
import { Table } from "antd";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import ReactPaginate from 'react-paginate';
import Beatloader from '../../../../../Common/Loaders/Beatloader';
import { getConsoleMAWBData, getFFAirExportConsoleShipmentList } from '../../../../../Redux/action/FreightForwarding/Console/FFAirExpAction';
import { convertYYYY_MM_DDtoDD_MMM_YYYYformat } from '../../../../../HelperFunctions';
import axios from 'axios';
import { adminMainUrl } from '../../../../../Config';
import { CircleLoader } from 'react-spinners';
import { useFormik } from 'formik';
import Select from 'react-select';
import { getHrmsBranchList } from '../../../../../Redux/action/Organisation/Branch/BranchAction';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import OverlayLoader from '../../../../../Common/Loaders/OverlayLoader';
import Tabbings from '../Tabs/Tabbings';
import AEConsoleMAWBDownloadOptionsModal from './AEConsoleMAWBDownloadOptionsModal';


const renderTooltipCell = (text, maxLength = 20, tooltipId = 'cell-tt') => {
    if (!text || text === '-' || text === '') return '-';
    const strText = String(text);
    if (strText.length > maxLength) {
        return (
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={tooltipId}>{strText}</Tooltip>}
            >
                <span className="cursor-pointer text-truncate d-inline-block" style={{ maxWidth: '160px', verticalAlign: 'middle' }}>
                    {strText}
                </span>
            </OverlayTrigger>
        );
    }
    return (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={tooltipId}>{strText}</Tooltip>}
        >
            <span>{strText}</span>
        </OverlayTrigger>
    );
};

const ListFFAirExpMAWB = ({ accessedModules, accessedPermission, title, ship_status, console_manifest_url, console_master_url, console_house_url, direct_master_url, job_order_url, tab_imp_exp, tab_air_sea }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [showLoader, setShowLoader] = useState(false);
    const [dataSource, setDataSource] = useState([]);

    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    //pagination 
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const queryParams = new URLSearchParams(location.search);

    let { HrmsBranchList } = useSelector(state => state?.BranchReducer || {});
    const filterBranchList = HrmsBranchList && Array.isArray(HrmsBranchList) ? HrmsBranchList.map((item) => ({
        value: item.branch_id,
        label: item.branch_name,
    })) : [];

    let { sidebarPermissionHRMSData } = useSelector(state => state?.NavbarReducer || {});
    const hasFilterPermission = sidebarPermissionHRMSData?.role_id == sidebarPermissionHRMSData?.user_id;

    useEffect(() => {
        if (token && user_id) {
            dispatch(getHrmsBranchList(token, user_id));
        }
    }, [token, user_id]);

    const formik = useFormik({
        initialValues: {
            search_text: queryParams.get("search_text") || "",
            branch_id: queryParams.get("branch_id") || "",
        },
        onSubmit: (values) => {
            const params = new URLSearchParams();
            Object.keys(values).forEach(key => {
                if (values[key]) {
                    params.append(key, values[key]);
                }
            });
            params.set("page", "1");
            navigate(`?${params.toString()}`);
        },
    });

    const resetFilters = () => {
        formik.resetForm();
        navigate(location.pathname);
    };

    useEffect(() => {
        if (token && user_id) {
            const queryParamsObj = new URLSearchParams(location.search);
            queryParamsObj.delete("page");
            const filterQueryString = queryParamsObj.toString();
            dispatch(getFFAirExportConsoleShipmentList(token, user_id, queryParams.get("page") ?? 1, ship_status, filterQueryString));
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token, user_id, location.pathname, location.search]);

    const [mawb_id, setMawb_id] = useState(0);
    const [mawb_number, setMawb_number] = useState("");
    const [showDownload, setShowDownload] = useState(false);

    const handleShowDownload = (id, mawb_number) => {
        if (!id) {
            toast.error("MAWB ID not found.");
            return;
        }
        setMawb_id(id);
        setMawb_number(mawb_number);
        setShowDownload(true);
        dispatch(getConsoleMAWBData(token, user_id, id))
    };

    const handleCloseDownload = () => setShowDownload(false);

    const {
        loadingFFAirExpConsoleShipmentList,
        FFAirExpConsoleShipmentList,
        FFAirExpConsoleShipmentListError,
        FFAirExpConsoleShipmentListCurrentPage,
        FFAirExpConsoleShipmentListTotalPage,
        FFAirExpConsoleShipmentListTotalData,


        loadingConsoleMAWBData,
        ConsoleMAWBData,
        ConsoleMAWBDataError
    } = useSelector(state => state?.FFAirExpReducer);


    // console.log(ConsoleMAWBData)

    useEffect(() => {
        if (loadingFFAirExpConsoleShipmentList) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
    }, [loadingFFAirExpConsoleShipmentList]);

    const [disableDownloadPDF, setDisableDownloadPDF] = useState(false);

    const downloadHAWB = (id, mawb_number) => {
        if (!id) { toast.error("HAWB not found"); return; }
        // console.log("hi hello")
        setDisableDownloadPDF(true);
        let config = { headers: { 'auth-token': token, user_id: user_id }, responseType: 'blob', };
        try {
            axios.get(`${adminMainUrl}/api/freight/forwarding/air/export/hawb/download-mawb?id=${id}`, config)
                .then(response => {
                    if (response.status == 200) {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `FF_AE_CONSOLE_MAWB_${mawb_number}.pdf`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setDisableDownloadPDF(false);
                    } else {
                        toast.error(response.error.message);
                        setDisableDownloadPDF(false);
                    }
                }).catch(error => {
                    console.log(error);
                    toast.error(error.message);
                    setDisableDownloadPDF(false);
                })
        } catch (error) {
            console.log(error);
            toast.error(error.message);
            setDisableDownloadPDF(false);
        }
    }


    useEffect(() => {
        if (FFAirExpConsoleShipmentList) {
            let arr = [];
            FFAirExpConsoleShipmentList.map((val, index) => {
                let shipperVal = ship_status == "HAWB" ?
                    (val.ff_consolehawb_shipment_customer ? val.ff_consolehawb_shipment_customer.name : "-") :
                    (val.ff_consolemawb_shipment_customer ? val.ff_consolemawb_shipment_customer.name : "-");

                let shipperBranchVal = ship_status == "HAWB" ?
                    (val.ff_consolehawb_shipment_customer_branch ? val.ff_consolehawb_shipment_customer_branch.branch_name : "-") :
                    (val.ff_consolemawb_shipment_customer_branch ? val.ff_consolemawb_shipment_customer_branch.branch_name : "-");

                let shipperBankVal = ship_status == "HAWB" ?
                    (val.ff_consolehawb_shipment_customer_branch_bank ? val.ff_consolehawb_shipment_customer_branch_bank.entity_name : "-") :
                    (val.ff_consolemawb_shipment_customer_branch_bank ? val.ff_consolemawb_shipment_customer_branch_bank.entity_name : "-");

                let consigneeVal = ship_status == "HAWB" ?
                    (val.ff_consolehawb_consignee_customer ? val.ff_consolehawb_consignee_customer.name : "-") :
                    (val.ff_consolemawb_consignee_customer ? val.ff_consolemawb_consignee_customer.name : "-");

                let consigneeBranchVal = ship_status == "HAWB" ?
                    (val.ff_consolehawb_consignee_customer_branch ? val.ff_consolehawb_consignee_customer_branch.branch_name : "-") :
                    (val.ff_consolemawb_consignee_customer_branch ? val.ff_consolemawb_consignee_customer_branch.branch_name : "-");

                let consigneeBankVal = ship_status == "HAWB" ?
                    (val.ff_consolehawb_consignee_customer_branch_bank ? val.ff_consolehawb_consignee_customer_branch_bank.entity_name : "-") :
                    (val.ff_consolemawb_consignee_customer_branch_bank ? val.ff_consolemawb_consignee_customer_branch_bank.entity_name : "-");

                let obj = {
                    sno: index + 1,
                    hawb_number: renderTooltipCell(ship_status == "HAWB" ? val.hawb_number : val.mawb_number, 18, `tt-mno-${index}`),
                    shipper: renderTooltipCell(shipperVal, 20, `tt-sh-${index}`),
                    shipper_branch: renderTooltipCell(shipperBranchVal, 18, `tt-shb-${index}`),
                    shipper_bank: renderTooltipCell(shipperBankVal, 18, `tt-shbk-${index}`),
                    consignee: renderTooltipCell(consigneeVal, 20, `tt-cn-${index}`),
                    consignee_branch: renderTooltipCell(consigneeBranchVal, 18, `tt-cnb-${index}`),
                    consignee_bank: renderTooltipCell(consigneeBankVal, 18, `tt-cnbk-${index}`),
                    agent_name: renderTooltipCell(val.issuing_carrier_agent_name, 20, `tt-an-${index}`),
                    agent_address: renderTooltipCell(val.issuing_carrier_agent_address, 22, `tt-aa-${index}`),
                    agent_iata: val.agent_iata_code || "-",
                    agent_account: val.agent_account_number || "-",
                    airway_bill_date: val.airwaybill_date ? convertYYYY_MM_DDtoDD_MMM_YYYYformat(val.airwaybill_date) : "-",
                    clearance_exec_date: val.clearance_Exec_date ? convertYYYY_MM_DDtoDD_MMM_YYYYformat(val.clearance_Exec_date) : "-",
                    csr_date: val.CSR_date ? convertYYYY_MM_DDtoDD_MMM_YYYYformat(val.CSR_date) : "-",
                    executed_at: val.executed_at ? convertYYYY_MM_DDtoDD_MMM_YYYYformat(val.executed_at) : "-",
                    current_status: val.current_status ? (
                        <OverlayTrigger placement="top" overlay={<Tooltip id={`tt-st-${index}`}>Status: {val.current_status}</Tooltip>}>
                            <span className={`badge badge-pill badge-status ${val.current_status.toLowerCase() === 'active' || val.current_status.toLowerCase() === 'completed' || val.current_status.toLowerCase() === 'approved' ? 'bg-success' : 'bg-info'}`}>
                                {val.current_status}
                            </span>
                        </OverlayTrigger>
                    ) : "-",
                    action: (
                        <div className="dropdown table-action">
                            <OverlayTrigger placement="top" overlay={<Tooltip id={`tt-act-${index}`}>Actions</Tooltip>}>
                                <Link to="#" className="action-icon" data-bs-toggle="dropdown">
                                    <i className="fa fa-ellipsis-v"></i>
                                </Link>
                            </OverlayTrigger>
                            <div className="dropdown-menu dropdown-menu-right">
                                {
                                    accessedPermission.includes("ff_ae_console_shipment_mawb_edit") && <div className="dropdown-item" onClick={() => { navigate(`/flexichain/job-order/freight-forwarding/shipment/air/export/console/mawb/edit/${btoa(val.id)}`) }} >
                                        <i className="fas fa-edit text-blue-light me-1"></i> Edit
                                    </div>
                                }
                                {
                                    accessedPermission.includes("ff_ae_console_shipment_mawb_download") && <button className="dropdown-item" onClick={() => { handleShowDownload(val.id, ship_status == "HAWB" ? val.hawb_number : val.mawb_number) }} disabled={disableDownloadPDF} >
                                        {disableDownloadPDF ? <><i className="fas fa-spinner fa-spin me-1"></i> Downloading...</> : <><i className="fa-solid fa-download text-blue-light me-1"></i> Download MAWB</>}
                                    </button>
                                }
                                {/* {val.current_status == "MAWB Generated" ? <div className="dropdown-item" onClick={() => { navigate(`/flexichain/job-order/freight-forwarding/shipment/air/export/console/mawb/edit/${btoa(val.id)}`) }} >
                                    <i className="fa-solid fa-clipboard text-blue-light me-1"></i> Generate Console Manifest
                                </div> : null} */}
                            </div>
                        </div>
                    ),
                };
                arr.push(obj);
            });
            setDataSource(arr);
        }
    }, [FFAirExpConsoleShipmentList]);

    useEffect(() => {
        if (FFAirExpConsoleShipmentListCurrentPage) {
            setCurrentPage(FFAirExpConsoleShipmentListCurrentPage);
        }

        if (FFAirExpConsoleShipmentListTotalPage) {
            setTotalPages(FFAirExpConsoleShipmentListTotalPage)
        }
    }, [
        FFAirExpConsoleShipmentListCurrentPage,
        FFAirExpConsoleShipmentListTotalPage,
        FFAirExpConsoleShipmentListTotalData
    ]);

    const handlePageClick = (selectedObject) => {
        const selectedPage = selectedObject.selected + 1;
        const params = new URLSearchParams(location.search);
        setCurrentPage(selectedPage);
        params.set("page", selectedPage);
        navigate(`?${params.toString()}`);
    };


    const columns = [
        { title: "#", dataIndex: "sno", key: "sno" },
        { title: `${ship_status == "HAWB" ? "HAWB No." : "MAWB No."}`, dataIndex: "hawb_number", key: "hawb_number" },
        { title: "Shipper", dataIndex: "shipper", key: "shipper" },
        { title: "Shipper Branch", dataIndex: "shipper_branch", key: "shipper_branch" },
        { title: "Shipper Bank", dataIndex: "shipper_bank", key: "shipper_bank" },
        { title: "Consignee", dataIndex: "consignee", key: "consignee" },
        { title: "Consignee Branch", dataIndex: "consignee_branch", key: "consignee_branch" },
        { title: "Consignee Bank", dataIndex: "consignee_bank", key: "consignee_bank" },
        { title: "Agent Name", dataIndex: "agent_name", key: "agent_name" },
        { title: "Agent Address", dataIndex: "agent_address", key: "agent_address" },
        { title: "Agent IATA", dataIndex: "agent_iata", key: "agent_iata" },
        { title: "Agent Account No", dataIndex: "agent_account", key: "agent_account" },
        { title: "Airway Bill Date", dataIndex: "airway_bill_date", key: "airway_bill_date" },
        { title: "Clearance Exec Date", dataIndex: "clearance_exec_date", key: "clearance_exec_date" },
        { title: "CSR Date", dataIndex: "csr_date", key: "csr_date" },
        { title: "Executed At", dataIndex: "executed_at", key: "executed_at" },
        // { title: "SLI Received", dataIndex: "sli_received", key: "sli_received" },
        { title: "Current Status", dataIndex: "current_status", key: "current_status" },
        { title: "Action", dataIndex: "action", key: "action" },
    ];


    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <>
                        <div className="page-wrapper">
                            <div className="content">
                                <div className="row">
                                    <div className="col-md-12">
                                        {/* Page Header */}
                                        <div className="page-header">
                                            <div className="row align-items-center">
                                                <div className="col-8">
                                                    <h4 className="page-title">
                                                        {title} <span className="count-title">{FFAirExpConsoleShipmentListTotalData ? FFAirExpConsoleShipmentListTotalData : "0"}</span>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                        {/* /Page Header */}
                                    </div>
                                </div>
                                <Tabbings
                                    console_manifest_url={console_manifest_url}
                                    console_master_url={console_master_url}
                                    console_house_url={console_house_url}
                                    direct_master_url={direct_master_url}
                                    job_order_url={job_order_url}
                                    tab_imp_exp={tab_imp_exp}
                                    tab_air_sea={tab_air_sea}
                                    accessedPermission={accessedPermission}
                                />
                                <div className="card">
                                    <div className="card-header">
                                        {accessedPermission.includes("ff_ae_console_shipment_mawb_add") && <div className="d-flex justify-content-end">
                                            <Link to="/flexichain/job-order/freight-forwarding/shipment/air/export/console/mawb/add" className="btn btn-sm btn-primary">+Add MAWB</Link>
                                        </div>}
                                    </div>
                                    <div className="card-body">
                                        {/* Filter Form */}
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-3">
                                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                                    <div className="icon-form mb-3 mb-sm-0 mx-1">
                                                        <span className="form-icon">
                                                            <i className="ti ti-search" />
                                                        </span>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Search..."
                                                            name='search_text'
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.search_text}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center flex-wrap row-gap-2">
                                                    {hasFilterPermission && (
                                                        <div className="form-sorts dropdown me-2">
                                                            <a href="javascript:void(0);" data-bs-toggle="dropdown" data-bs-auto-close="outside">
                                                                <i className="ti ti-filter-share" /> Filter
                                                            </a>
                                                            <div className="filter-dropdown-menu dropdown-menu dropdown-menu-md-end p-3">
                                                                <div className="filter-set-view">
                                                                    <div className="filter-set-head">
                                                                        <h4><i className="ti ti-filter-share" /> Filter</h4>
                                                                    </div>
                                                                    <table className="content-table">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td><label>BRANCH</label></td>
                                                                                <td className="input_box_filter">
                                                                                    <Select
                                                                                        className="ms-2"
                                                                                        classNamePrefix="react-select"
                                                                                        placeholder="Select Branch"
                                                                                        options={filterBranchList}
                                                                                        isClearable
                                                                                        styles={{
                                                                                            container: (base) => ({ ...base, width: '100%', minWidth: '220px' }),
                                                                                            control: (base) => ({ ...base, minHeight: '33px', height: '32px', fontSize: '12px' }),
                                                                                            valueContainer: (base) => ({ ...base, height: '32px', padding: '0 6px' }),
                                                                                            indicatorsContainer: (base) => ({ ...base, height: '32px' }),
                                                                                            menu: (base) => ({ ...base, fontSize: '12px' }),
                                                                                            option: (base) => ({ ...base, fontSize: '12px', padding: '4px 8px' }),
                                                                                        }}
                                                                                        value={filterBranchList.find(opt => opt.value == formik.values.branch_id) || null}
                                                                                        onChange={(selected) => formik.setFieldValue("branch_id", selected ? selected.value : "")}
                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <div className="filter-reset-btns">
                                                                        <div className="row">
                                                                            <div className="col-6">
                                                                                <a href="javascript:void(0);" className="btn btn-light w-100" onClick={resetFilters}>Reset</a>
                                                                            </div>
                                                                            <div className="col-6">
                                                                                <button type="submit" className="btn btn-primary w-100">Filter</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </form>

                                        {/* Contact List */}
                                        <div className="table-responsive custom-table">
                                            <Table className="table datanew dataTable no-footer"
                                                // rowSelection={rowSelection} 
                                                dataSource={dataSource}
                                                columns={columns}
                                                pagination={false} />
                                        </div>

                                        <div className="row align-items-center">
                                            {dataSource.length ? <div className="pagination-controls my-5 d-flex justify-content-center align-items-center react-custom-paginate">
                                                <ReactPaginate
                                                    previousLabel={<img src="/img/right.png" alt="Previous" />}
                                                    nextLabel={<img src="/img/left.png" alt="Next" />}
                                                    breakLabel="..."
                                                    breakClassName="break-me"
                                                    pageCount={totalPages}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={5}
                                                    onPageChange={handlePageClick}
                                                    containerClassName="pagination"
                                                    activeClassName="active"
                                                    forcePage={currentPage - 1}
                                                />
                                            </div> :
                                                null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
            }
            {
                disableDownloadPDF && <OverlayLoader />
            }


            <AEConsoleMAWBDownloadOptionsModal
                show={showDownload}
                handleClose={handleCloseDownload}
                token={token}
                user_id={user_id}
                id={mawb_id}
                mawb_number={mawb_number}
                ConsoleMAWBData={ConsoleMAWBData}
                loadingConsoleMAWBData={loadingConsoleMAWBData}
            />
        </>

    )
}

export default ListFFAirExpMAWB